import React, { useState, useEffect } from 'react';
import './../entrydoor.css';

const LocationTag = ({ value, onChange, label = 'Location/Tag' , disabled = false }) => {
    const [selectedLocationTag, setSelectedLocationTag] = useState(value || null);

    useEffect(() => {
        setSelectedLocationTag(value || null);
    }, [value]);


    const handleLocationTagChange = (e) => {
        setSelectedLocationTag(e.target.value);
        onChange(e.target.value)
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="LocationTag">{label}</label>
            <input
                disabled={disabled}
                id="LocationTag"
                value={selectedLocationTag}
                onChange={handleLocationTagChange}
            >
            </input>
        </div>
    );
};

export default LocationTag;
